define([
  "jquery",
  "globals",
  "jquery-validate"],
function ($, globals) {
  var defaultErrorMessage = 'Please enter a valid email address.'
  var errorMessage = defaultErrorMessage
  $(function() {
    $('.gcc-enews').validate({
      rules: {
        email: {
          required: true,
          email: true
        }
      },
      messages: {
        email: {
          required: defaultErrorMessage,
          email: defaultErrorMessage
        }
      },
      errorPlacement: function(error, element) {
        element.parents('.gcc-enews').find('.gcc-input-help').html(error[0].outerText)
      },
      onfocusout: function(e) {
        this.element(e)
        if ($(e).val().trim() !== '') {
          $(e).addClass('filled')
        } else {
          $(e).removeClass('filled')
          $(e).parents('.gcc-enews').find('.gcc-input-help').html('')
        }
        if (this.valid()) {
          $(e).parents('.gcc-enews').find('.gcc-input-help').html('')
          $(e).parents('.gcc-enews').find('button').prop('disabled', false)
        } else {
          $(e).parents('.gcc-enews').find('button').prop('disabled', true)
        }
      },
      onfocusin: function(element) {
        if ($(element).val() === defaultErrorMessage || $(element).val() === errorMessage) {
          $(element).val('')
        }
      },
      onkeyup: function(e) {
        this.element(e)
        if ($(e).val().trim() !== '') {
          $(e).addClass('filled')
        } else {
          $(e).removeClass('filled')
          $(e).parents('.gcc-enews').find('.gcc-input-help').html('')
        }
        $(e).parents('.gcc-enews').find('.gcc-input-help').html('')
        if (this.valid()) {
          $(e).parents('.gcc-enews').find('button').prop('disabled', false)
        } else {
          $(e).parents('.gcc-enews').find('button').prop('disabled', true)
        }
      },
      focusInvalid: false
    })
    $('.gcc-enews').on('submit', function(e) {
      e.preventDefault()
      if ($(this).valid()) {
        $('.gcc-enews').find('button').prop('disabled', true)
        var $validator = $(this).validate()
        var action = $(this).attr('action')
        var server = location.protocol + '//' + location.hostname
        var parameters = {
          ThanksPage: server + '/infopage/enews-confirm',
          ErrorPage: server + '/infopage/enews-error-footer',
          UnsubscribePage: server + '/infopage/unsubemail',
          ListIdV1: globals.exactTarget.listIdV1,
          MemberIdV1: globals.exactTarget.memberIdV1,
          ListId: globals.exactTarget.listId,
          MemberId: globals.exactTarget.memberId,
          EmailAddress: $('#gcc-enews-email').val()
        }
        $.post(action, $.param(parameters), function(data) {
          if (data.errorCode) {
            errorMessage = data.message
            var errors = {
              email: data.message
            }
            $validator.showErrors(errors)
          } else {
            $('.gcc-input-help').html(data.message)
          }
        }, 'json')
      }
    })
  })
})
